import { render, staticRenderFns } from "./MobileNavigationList.vue?vue&type=template&id=3632a6ba"
import script from "./MobileNavigationList.vue?vue&type=script&lang=js"
export * from "./MobileNavigationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports